export function getApiBaseUrl(): string {
  let apiBaseUrl = process.env.REACT_APP_PLATZ_API_URL;
  if (process.env.REACT_APP_CUSTOM_ENV === "ngrok") {
    //TODO: would rather this ngrok url be in an e.g. .env file?
    apiBaseUrl = "https://moccasin-awaited-reliably.ngrok-free.app";
  }
  if (apiBaseUrl === undefined) {
    throw new Error("api base url couldn't be deduced! this shouldn't happen");
  }
  return apiBaseUrl;
}
